import elementResizeDetectorMaker from "element-resize-detector"

export default {
  data() {
    return {
      layoutMounted: false,
      layoutMountPromise: null,
      varValueMap: {},
      currentNodeId: null,
      onScrollThrottle: null
    }
  },
  computed: {
    componentTopMap() {
      let result = {}
      this.layout?.forEach(
        item =>
          (result[item.i] = {
            start: Number(item.y) * 40 + Number(item.y) * 10,
            end:
              Number(item.y) * 40 +
              Number(item.y) * 10 +
              Number(item.h) * 40 +
              (Number(item.h) - 1) * 10
          })
      )
      return result
    },
    storylineNodeMap() {
      let result = {}
      this.board.storyline.map(node => {
        result[node.id] = this.componentTopMap[node.chartId]
      })
      return result
    },
    storylineTops() {
      return this.board.storyline.map(node => {
        return Object.assign({}, node, { top: this.componentTopMap[node.chartId] })
      })
    }
  },
  created() {
    this.listenGridLayoutMount()
    this.onScrollThrottle = this._.throttle(this.onScroll, 50)
  },
  methods: {
    async getVarValueMap(from, conditions) {
      if (from === "boardEdit") await this.layoutMountPromise
      else await this.$nextTick()
      let varValueMap = {}
      let conditionRef = from === "boardEdit" ? "condition" : "phoneCondition"
      conditions
        .filter(condition => condition.type === "text")
        .forEach(condition => {
          let ref = this.$refs[conditionRef]?.find(vm => vm.condition === condition)
          varValueMap[condition.id] = ref?.getValue()
        })
      this.varValueMap = Object.assign({}, this.varValueMap, varValueMap)
    },
    async query(from, conditions, isDraw = true) {
      let conditionRef = from === "boardEdit" ? "condition" : "phoneCondition"
      let chartRef = from === "boardEdit" ? "image" : "phoneImage"
      let queryFilterMap = {}
      let resFilterMap = {}
      let results = []
      await Promise.all(
        conditions.map(async condition => {
          let ref = this.$refs[conditionRef].find(vm => vm.condition === condition)
          ref.getVerifyResult()
          results.push(ref.$data.result)
          await Promise.all(
            condition.charts.map(async chart => {
              let filters
              filters = await ref.getFilters(chart)
              if (condition.dataKind === "raw-data") {
                if (this._.keys(queryFilterMap).includes(chart.chartId)) {
                  queryFilterMap[chart.chartId].push(...filters)
                } else {
                  queryFilterMap[chart.chartId] = filters
                }
              } else {
                if (this._.keys(resFilterMap).includes(chart.chartId)) {
                  resFilterMap[chart.chartId].push(...filters)
                } else {
                  resFilterMap[chart.chartId] = filters
                }
              }
            })
          )
        })
      )
      if (results.includes(false)) return
      let charts =
        from === "boardEdit"
          ? this.board.charts
          : this.itemList.filter(s => s.type !== "query" && s.visible)
      charts.forEach((chart, index) => {
        if (this._.keys(queryFilterMap).includes(chart.chartId)) {
          chart.queryFilters = queryFilterMap[chart.chartId]
        }
        if (this._.keys(resFilterMap).includes(chart.chartId)) {
          chart.resultFilters = resFilterMap[chart.chartId]
        }
        if (isDraw && (chart.queryFilters || chart.resultFilters)) {
          this.$refs[chartRef][index].init(chart)
        }
      })
    },
    getLayout() {
      this.layout = this.board.charts
        .map(chart => {
          return Object.assign({}, chart, {
            itemType: "chart",
            x: chart.position[1],
            y: chart.position[0],
            w: chart.position[2],
            h: chart.position[3],
            i: chart.chartId
          })
        })
        .concat(
          this.board.queries.map(query => {
            return Object.assign({}, query, {
              itemType: "query",
              x: query.position[1],
              y: query.position[0],
              w: query.position[2],
              h: query.position[3],
              i: query.queryId
            })
          })
        )
        .concat(
          this.board.riches?.map(rich => {
            return Object.assign({}, rich, {
              itemType: "rich",
              x: rich.position[1],
              y: rich.position[0],
              w: rich.position[2],
              h: rich.position[3],
              i: rich.richId
            })
          }) || []
        )
        .concat(
          this.board.viewControls?.map(view => {
            return Object.assign({}, view, {
              itemType: "view",
              x: view.position[1],
              y: view.position[0],
              w: view.position[2],
              h: view.position[3],
              i: view.id
            })
          }) || []
        )
        .concat(
          this.board.images?.map(image => {
            return Object.assign({}, image, {
              itemType: "image",
              x: image.position[1],
              y: image.position[0],
              w: image.position[2],
              h: image.position[3],
              i: image.id
            })
          }) || []
        )
    },
    listenContent() {
      let contentDom = document.getElementById("content")
      if (!contentDom) return
      let erd = elementResizeDetectorMaker()
      erd.listenTo(contentDom, () => {
        setTimeout(() =>
          this.board.charts.forEach((chart, index) => this.$refs.image[index]?.resize())
        )
      })
    },
    listenGridLayoutMount() {
      this.layoutMountPromise = new Promise(resolve => {
        let unwatch = this.$watch("layoutMounted", () => {
          unwatch()
          resolve()
          this.listenContent()
        })
      })
    },
    async queryCharts() {
      await this.layoutMountPromise
      await Promise.all(
        this.board.queries.map(query => this.query("boardEdit", query.conditions, false))
      )
      this.board.charts.forEach((figure, index) => this.$refs.image[index].init(figure))
    },
    goChart(node) {
      this.currentNodeId = node.id
      let chartId = node.chartId
      let index = this._.findIndex(this.layout, ["i", chartId])
      if (index === -1) this.$message.error("节点【" + node.name + "】关联的组件不存在")
      else this.$refs.component[index]?.scrollIntoView()
    },
    onScroll() {
      let scrollTop = this.$refs.content.scrollTop
      for (let i = 0; i < this.board.storyline.length; i++) {
        if (
          this.storylineNodeMap[this.board.storyline[i].id] &&
          this.storylineNodeMap[this.board.storyline[i].id].start < scrollTop &&
          this.storylineNodeMap[this.board.storyline[i].id].end > scrollTop
        ) {
          this.currentNodeId = this.board.storyline[i].id
          break
        }
      }
    },
    getMostTop() {
      this.currentNodeId = this._.isEmpty(this.storylineTops)
        ? null
        : this._.minBy(this.storylineTops, "top").id
    }
  }
}
